import { CartContent } from '../cart/cart.types'

export const getOffersCustomFields = (product: any, salesChannel: string) => {
  const customFields = product.translated?.customFields || product.customFields
  if (!customFields) {
    // Probably a Deesse Event line item
    return {
      isCustomerOffer: false,
      isHostOffer: false,
      bonus: 0,
      isFreeProduct: false,
      isSpecialOffer: false,
      isKofferbon: false,
      kofferbonMaxQty: 0,
      customerOfferPoints: 0,
      availableFrom: undefined,
      availableTo: undefined,
    }
  }
  const suffix = salesChannel.replace('-', '_').toLowerCase()
  const isCustomerOffer = customFields['is_customer_offer_' + suffix]
  const isHostOffer = customFields['is_host_offer_' + suffix]
  const bonus = customFields['bonus']
  const isFreeProduct = customFields['is_free_product_' + suffix]
  const isSpecialOffer = customFields['is_special_offer_' + suffix]
  const isKofferbon = customFields['is_kofferbon_' + suffix]
  const kofferbonMaxQty: number =
    customFields['kofferbon_max_qty_' + suffix] ?? 1
  const customerOfferPoints: number =
    customFields!['customer_offer_points_' + suffix]
  const availableFrom: string | undefined =
    customFields['available_from_' + suffix]
  const availableTo: string | undefined = customFields['available_to_' + suffix]
  return {
    isCustomerOffer,
    isHostOffer,
    bonus,
    isFreeProduct,
    isSpecialOffer,
    isKofferbon,
    kofferbonMaxQty,
    customerOfferPoints,
    availableFrom,
    availableTo,
  }
}

export const getRemainingPoints = (
  extensions: CartContent['extensions'],
  offerType: 'host' | 'customer' | 'free',
) => {
  switch (offerType) {
    case 'host':
      return (
        extensions?.customMessagesHostOffer?.data?.remainingHostOffersPoints ||
        0
      )
    case 'customer':
      return (
        extensions?.customMessagesCustomerOffer?.data
          ?.remainingCustomerOffersPoints || 0
      )
    case 'free':
      return extensions?.customMessagesFreeProducts?.data?.remainingPoints || 0
  }
}

export const getOfferType = (
  lineItem: CartContent['lineItems'][0],
  salesChannel: string,
): 'host' | 'customer' | 'free' | null => {
  const fields = getOffersCustomFields(lineItem.payload, salesChannel)
  if (fields.isHostOffer && lineItem.payload?.isOffer) {
    return 'host'
  }

  if (fields.isCustomerOffer && lineItem.payload?.isOffer) {
    return 'customer'
  }

  if (fields.isFreeProduct && lineItem.payload?.isOffer) {
    return 'customer'
  }
  return null
}
